(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.__bound = false;
        this.__timer = null;
        this.__activeIndex = 0;
      }

      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__viewport = this.querySelector('.announcement-bar__viewport');
        this.__messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
        this.__live = this.querySelector('[data-announcement-live]');
        this.__dwell = parseInt(this.dataset.dwell, 10) || 5000;

        if (this.__messages.length < 2) return;

        this.__reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.__mobile = window.matchMedia('(max-width: 749px)');
        this.__onVisibility = () => this.__sync();
        this.__onMotionChange = () => this.__sync();
        this.__onMobileChange = () => {
          if (this.__mobile.matches) {
            this.__apply();
          } else {
            this.__spreadDesktop();
          }
          this.__sync();
        };

        this.__reducedMotion.addEventListener('change', this.__onMotionChange);
        this.__mobile.addEventListener('change', this.__onMobileChange);
        document.addEventListener('visibilitychange', this.__onVisibility);
        this.__sync();
      }

      disconnectedCallback() {
        this.__stop();
        if (this.__reducedMotion) this.__reducedMotion.removeEventListener('change', this.__onMotionChange);
        if (this.__mobile) this.__mobile.removeEventListener('change', this.__onMobileChange);
        document.removeEventListener('visibilitychange', this.__onVisibility);
        this.__bound = false;
      }

      /* Desktop draws all messages as one static spread row - the timer is
         inert above 749px. Rotation runs only on mobile, only with motion
         allowed, only while the tab is visible (usp-banner pattern). */
      __sync() {
        const shouldRotate =
          this.__mobile.matches &&
          !this.__reducedMotion.matches &&
          !document.hidden;
        if (shouldRotate) {
          this.__start();
        } else {
          this.__stop();
          if (!this.__mobile.matches) this.__spreadDesktop();
        }
      }

      __start() {
        if (this.__timer) return;
        this.__timer = setInterval(() => this.__advance(), this.__dwell);
      }

      __stop() {
        if (this.__timer) {
          clearInterval(this.__timer);
          this.__timer = null;
        }
      }

      /* Desktop shows every message to assistive tech - the rotation-time
         aria-hidden bookkeeping does not apply to the spread row. */
      __spreadDesktop() {
        this.__messages.forEach((message) => message.removeAttribute('aria-hidden'));
      }

      __advance() {
        this.__activeIndex = (this.__activeIndex + 1) % this.__messages.length;
        this.__apply();
      }

      __apply() {
        this.__viewport.dataset.active = String(this.__activeIndex);
        this.__messages.forEach((message, index) => {
          const active = index === this.__activeIndex;
          message.classList.toggle('is-active', active);
          if (active) {
            message.removeAttribute('aria-hidden');
          } else {
            message.setAttribute('aria-hidden', 'true');
          }
        });
        if (this.__live) {
          const strings = window.__announcementBarStrings;
          this.__live.textContent = String(strings.liveTemplate)
            .replace('@i', String(this.__activeIndex + 1))
            .replace('@y', String(this.__messages.length));
        }
      }
    }
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('article-grid')) {
  class ArticleGrid extends HTMLElement {
    connectedCallback() {
      if (this.__bound) return;
      this.__bound = true;
      this.__onClick = (event) => {
        const trigger = event.target.closest('[data-load-more]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        this.loadMore(trigger);
      };
      this.addEventListener('click', this.__onClick);
    }

    disconnectedCallback() {
      if (this.__onClick) this.removeEventListener('click', this.__onClick);
      this.__bound = false;
    }

    async loadMore(trigger) {
      if (this.dataset.loading === 'true') return;

      const href = trigger.getAttribute('href');
      const sectionId = this.dataset.sectionId;
      const fetchUrl =
        href + (href.includes('?') ? '&' : '?') + 'section_id=' + sectionId;

      this.dataset.loading = 'true';
      trigger.setAttribute('aria-busy', 'true');
      trigger.setAttribute('aria-disabled', 'true');
      trigger.classList.add('is-loading');

      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error('request failed');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const list = this.querySelector('[data-grid-list]');
        const newItems = doc.querySelectorAll('[data-grid-list] > li');
        newItems.forEach((item) => {
          list.appendChild(document.adoptNode(item));
        });

        this.updatePagination(doc);

        history.replaceState(null, '', new URL(href, location.href).pathname + new URL(href, location.href).search);

        const firstNewCard = newItems[0];
        if (firstNewCard) {
          const focusTarget = firstNewCard.querySelector('a');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }
      } catch (error) {
        window.location.href = href;
        return;
      } finally {
        delete this.dataset.loading;
        trigger.removeAttribute('aria-busy');
        trigger.removeAttribute('aria-disabled');
        trigger.classList.remove('is-loading');
      }
    }

    updatePagination(doc) {
      const nav = this.querySelector('[data-pagination]');
      const newNav = doc.querySelector('[data-pagination]');
      if (!nav || !newNav) return;

      const countEl = nav.querySelector('[data-count-text]');
      const newCountEl = newNav.querySelector('[data-count-text]');
      if (countEl && newCountEl) countEl.textContent = newCountEl.textContent;

      const fill = nav.querySelector('[data-progress-fill]');
      const newFill = newNav.querySelector('[data-progress-fill]');
      if (fill && newFill) {
        fill.style.setProperty(
          '--progress',
          newFill.style.getPropertyValue('--progress') || '1'
        );
      }

      const track = nav.querySelector('[role="progressbar"]');
      if (track) {
        track.setAttribute(
          'aria-valuenow',
          newNav.querySelector('[role="progressbar"]')?.getAttribute('aria-valuenow') || ''
        );
      }

      if (newNav.hasAttribute('data-hidden')) nav.setAttribute('data-hidden', 'true');

      const button = nav.querySelector('[data-load-more]');
      const newButton = newNav.querySelector('[data-load-more]');
      if (button && !newButton) {
        /* Removed, not hidden: the shared button snippet sets display:inline-flex,
           which beats the [hidden] UA rule - so at 46 of 46 the control stayed on
           screen and re-fetched the final page forever (engineer-reported). */
        button.remove();
      } else if (button && newButton) {
        button.setAttribute('href', newButton.getAttribute('href'));
      }
    }
  }
  customElements.define('article-grid', ArticleGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__b2bForm) return;
    window.__b2bForm = true;

    document.addEventListener('DOMContentLoaded', function () {
      var heading = document.querySelector('[data-b2b-form-success-heading]');
      if (heading) heading.focus();

      var firstError = document.querySelector(
        '.b2b-form .field--error .field__input, .b2b-form .field--error .field__box'
      );
      if (firstError) firstError.focus();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.b2b-form__form');
      if (!form || event.defaultPrevented) return;

      form.classList.add('is-submitting');
      var button = form.querySelector('[data-b2b-form-submit]');
      if (button) {
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bestsellers-rail')) return;

    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

    class BestsellersRail extends HTMLElement {
      connectedCallback() {
        if (this.__bsBound) return;
        this.__bsBound = true;

        this.__rail = this.querySelector('[data-bestsellers-rail]');
        this.__arrows = this.querySelector('.section-header__arrows');
        this.__prev = this.querySelector('[data-carousel-prev]');
        this.__next = this.querySelector('[data-carousel-next]');

        if (!this.__rail) return;

        this.__onScroll = function () {
          window.requestAnimationFrame(this.update.bind(this));
        }.bind(this);
        this.__onResize = this.update.bind(this);

        this.__rail.addEventListener('scroll', this.__onScroll, { passive: true });
        window.addEventListener('resize', this.__onResize, { passive: true });

        /* A window resize listener alone is not enough: update() must also
           run on the rail's first real layout and on every later size
           change (images arriving, editor re-renders) or the arrows show
           enabled over a rail with nothing to scroll - the same defect the
           product-carousel element fixed with an observer (QA 2026-09-02). */
        if (window.ResizeObserver) {
          this.__ro = new ResizeObserver(this.__onResize);
          this.__ro.observe(this.__rail);
        }

        this.update();
      }

      disconnectedCallback() {
        if (!this.__bsBound) return;
        this.__bsBound = false;
        if (this.__rail && this.__onScroll) this.__rail.removeEventListener('scroll', this.__onScroll);
        window.removeEventListener('resize', this.__onResize);
        if (this.__ro) { this.__ro.disconnect(); this.__ro = null; }
      }

      update() {
        if (!this.__rail) return;
        var max = this.__rail.scrollWidth - this.__rail.clientWidth;

        /* No overflow (5 products at desktop, or a short collection):
           both arrows hide and disable - the component-17 empty-state
           rule. The [hidden] guard needs the section CSS override too
           (the snippet's author display beats the UA hidden rule), but
           the disabled state keeps the behaviour honest on its own.

           data-rail-overflow on the host mirrors that same one piece of
           state outward for CSS. Overflow is exactly what decides
           whether the arrows render, so at desktop widths the attribute
           IS "arrows present" - and it is what moves the CTA below the
           carousel (Kate, design QA 8 Sep 2026). Stamped from here
           rather than read back with a CSS :has() so this method stays
           the single owner of the overflow state, the same reason
           data-at-start / data-at-end live on the rail. */
        if (max <= 1) {
          this.removeAttribute('data-rail-overflow');
          if (this.__arrows) this.__arrows.hidden = true;
          if (this.__prev) this.__prev.disabled = true;
          if (this.__next) this.__next.disabled = true;
          this.__rail.removeAttribute('data-at-start');
          this.__rail.removeAttribute('data-at-end');
          return;
        }

        this.setAttribute('data-rail-overflow', '');
        if (this.__arrows) this.__arrows.hidden = false;

        var atStart = this.__rail.scrollLeft <= 1;
        var atEnd = this.__rail.scrollLeft >= max - 1;
        if (atStart) {
          this.__rail.setAttribute('data-at-start', '');
        } else {
          this.__rail.removeAttribute('data-at-start');
        }
        if (atEnd) {
          this.__rail.setAttribute('data-at-end', '');
        } else {
          this.__rail.removeAttribute('data-at-end');
        }

        if (this.__prev) this.__prev.disabled = atStart;
        if (this.__next) this.__next.disabled = atEnd;
      }

      /* One card + one gap (checklist 11): measured off the real items so
         a breakpoint change never desyncs the step. */
      stepSize() {
        var items = this.__rail.querySelectorAll('.bestsellers__item');
        if (items.length < 2) {
          if (items.length === 1) return items[0].getBoundingClientRect().width;
          return this.__rail.clientWidth;
        }
        var gap = parseFloat(getComputedStyle(this.__rail).columnGap) || 0;
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      }
    }

    customElements.define('bestsellers-rail', BestsellersRail);

    /* Arrow driving is delegated at document level exactly once (one
       owner per trigger) so Section Rendering editor swaps never
       double-bind and arrows keep working after shopify:section:load
       re-upgrades. Scoped to this element root: product-carousel binds
       the same data-carousel hooks to its own root and ignores foreign
       arrows, and this handler ignores its arrows in turn. */
    if (!window.__bestsellersRailArrowsInit) {
      window.__bestsellersRailArrowsInit = true;

      document.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-carousel-prev]');
        var next = event.target.closest('[data-carousel-next]');
        if (!prev && !next) return;

        var root = (prev || next).closest('bestsellers-rail');
        if (!root) return;
        var rail = root.querySelector('[data-bestsellers-rail]');
        if (!rail) return;

        var step = root.stepSize();
        if (step <= 0) return;

        rail.scrollBy({
          left: next ? step : -step,
          behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Scrollspy: owns the az-jump-bar's active-letter state (aria-current +
    // .is-active) from this section's group headings. Delegated, swap-safe,
    // no literal UI English (no strings needed).
    function init() {
      if (window.__brandsDirectorySpy) return;
      var roots = document.querySelectorAll('[data-brands-directory]');
      if (!roots.length) return;
      window.__brandsDirectorySpy = true;

      var headings = document.querySelectorAll(
        '[data-brands-directory] .brands-directory__letter[data-letter]'
      );
      if (!headings.length || !('IntersectionObserver' in window)) return;

      var active = null;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var letter = entry.target.getAttribute('data-letter');
            if (letter === active) return;
            active = letter;
            document.querySelectorAll('[data-az-jump-bar] [data-az-letter]').forEach(function (link) {
              var isMatch = link.getAttribute('data-az-letter') === letter;
              link.classList.toggle('is-active', isMatch);
              if (isMatch) {
                link.setAttribute('aria-current', 'true');
              } else {
                link.removeAttribute('aria-current');
              }
            });
          });
        },
        { rootMargin: '-96px 0px -66% 0px', threshold: 0 }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('brands-intro-carousel')) return;

    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

    class BrandsIntroCarousel extends HTMLElement {
      connectedCallback() {
        if (this.__biBound) return;
        this.__biBound = true;

        this.__track = this.querySelector('[data-carousel-track]');
        this.__prev = this.querySelector('[data-carousel-prev]');
        this.__next = this.querySelector('[data-carousel-next]');
        this.__controls = this.querySelector('.brands-intro__controls');

        /* No arrows means four or fewer tiles - nothing to drive. */
        if (!this.__track || !this.__prev || !this.__next) return;

        this.__onScroll = this.onScroll.bind(this);
        this.__onResize = this.onResize.bind(this);

        this.__track.addEventListener('scroll', this.__onScroll, { passive: true });
        window.addEventListener('resize', this.__onResize, { passive: true });

        /* Observe the track so the arrow state is recomputed on its first
           real layout and on every later size change (images arriving, the
           editor resizing), not just on window resize. */
        if (window.ResizeObserver) {
          this.__ro = new ResizeObserver(this.__onResize);
          this.__ro.observe(this.__track);
        }

        this.onResize();
      }

      disconnectedCallback() {
        if (!this.__biBound) return;
        this.__biBound = false;
        if (this.__track) this.__track.removeEventListener('scroll', this.__onScroll);
        window.removeEventListener('resize', this.__onResize);
        if (this.__ro) { this.__ro.disconnect(); this.__ro = null; }
      }

      tiles() {
        return this.__track.children;
      }

      visibleCount() {
        var items = this.tiles();
        if (items.length === 0) return 1;
        var gap = parseFloat(getComputedStyle(this.__track).columnGap) || 0;
        var trackWidth = this.__track.clientWidth;
        var first = items[0].getBoundingClientRect().width;
        if (first <= 0) return 1;
        return Math.max(1, Math.round((trackWidth + gap) / (first + gap)));
      }

      stepSize() {
        var items = this.tiles();
        if (items.length < 2) {
          if (items.length === 1) return items[0].getBoundingClientRect().width;
          return this.__track.clientWidth;
        }
        var gap = parseFloat(getComputedStyle(this.__track).columnGap) || 0;
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      }

      scrollByView() {
        var visible = this.visibleCount();
        var gap = parseFloat(getComputedStyle(this.__track).columnGap) || 0;
        return (this.stepSize() + gap) * visible;
      }

      onScroll() {
        window.requestAnimationFrame(this.update.bind(this));
      }

      /* Update synchronously on resize/connect so a tab that loaded hidden
         does not keep the server-rendered arrow state (rAF is suspended in a
         backgrounded tab); rAF stays only on the scroll path. */
      onResize() {
        this.update();
      }

      update() {
        var max = this.__track.scrollWidth - this.__track.clientWidth;

        /* Few-tiles state: nothing to scroll (four or fewer fill the row) -
           hide the whole controls wrapper and leave the track static. The
           threshold keeps a sub-pixel overhang from counting as scrollable. */
        if (max <= 1) {
          this.__prev.disabled = true;
          this.__next.disabled = true;
          if (this.__controls) this.__controls.hidden = true;
          return;
        }

        if (this.__controls) this.__controls.hidden = false;

        var atStart = this.__track.scrollLeft <= 1;
        var atEnd = this.__track.scrollLeft >= max - 1;

        this.__prev.disabled = atStart;
        this.__next.disabled = atEnd;
      }
    }

    customElements.define('brands-intro-carousel', BrandsIntroCarousel);

    /* Arrow driving is delegated at document level exactly once so Section
       Rendering swaps never double-bind. */
    if (!window.__brandsIntroArrowsInit) {
      window.__brandsIntroArrowsInit = true;

      document.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-carousel-prev]');
        var next = event.target.closest('[data-carousel-next]');
        if (!prev && !next) return;

        var root = (prev || next).closest('brands-intro-carousel');
        var track = root && root.querySelector('[data-carousel-track]');
        if (!track || !root) return;

        var distance = root.scrollByView();
        if (distance <= 0) return;

        track.scrollBy({
          left: prev ? -distance : distance,
          behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cart-banner')) return;

    customElements.define(
      'cart-banner',
      class CartBanner extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.sectionId = this.dataset.sectionId;
          this.__onCartUpdated = this.__handleCartUpdated.bind(this);
          document.addEventListener('cart:updated', this.__onCartUpdated);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          document.removeEventListener('cart:updated', this.__onCartUpdated);
          if (this.__abort) this.__abort.abort();
        }

        /* Only refetch when the count crossed the zero boundary - quantity
           changes inside the filled state do not alter this section. */
        __handleCartUpdated(event) {
          var cart = event.detail && event.detail.cart;
          if (cart && typeof cart.item_count === 'number') {
            var willBeEmpty = cart.item_count === 0;
            var isEmpty = this.hasAttribute('data-cart-empty');
            if (willBeEmpty === isEmpty) return;
          }
          this.__refresh();
        }

        __refresh() {
          if (!this.sectionId) return;
          if (this.__inflight) return;
          this.__inflight = true;
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          if (this.__abort) this.__abort.abort();
          this.__abort = new AbortController();
          fetch(root + '?sections=' + encodeURIComponent(this.sectionId), {
            signal: this.__abort.signal
          })
            .then(function (response) {
              if (!response.ok) throw new Error('cart-banner fetch failed');
              return response.json();
            })
            .then(function (data) {
              var html = data && data[this.sectionId];
              if (!html) return;
              var tpl = document.createElement('template');
              tpl.innerHTML = html.trim();
              var fresh = tpl.content.querySelector('cart-banner');
              if (fresh && this.parentNode) {
                this.parentNode.replaceChild(fresh, this);
              }
            }.bind(this))
            .catch(function (error) {
              if (error && error.name !== 'AbortError') {
                window.location.reload();
              }
            })
            .then(function () {
              this.__inflight = false;
            }.bind(this));
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-items"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cart-items')) return;

    customElements.define(
      'cart-items',
      class CartItems extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.sectionId = this.getAttribute('data-section-id');
          this.__onCartUpdated = this.__handleCartUpdated.bind(this);
          document.addEventListener('cart:updated', this.__onCartUpdated);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          document.removeEventListener('cart:updated', this.__onCartUpdated);
          if (this.__abort) this.__abort.abort();
        }

        /* cart:updated arrives from this page's own child controllers
           (cart-line-item steppers/removes, cart-addons adds, the promo
           apply) AND from the cart flyout or any other surface. The
           child controllers bundle this section's re-rendered HTML in
           their response when present; this section only needs to
           fetch for itself when no bundled markup carries it. */
        __handleCartUpdated(event) {
          var detail = event.detail || {};
          if (this.__swapWithBundled(detail.sections)) return;
          this.__refresh();
        }

        __swapWithBundled(sections) {
          if (!sections) return false;
          var html = sections[this.sectionId];
          if (!html) return false;
          var tpl = document.createElement('template');
          tpl.innerHTML = html.trim();
          var fresh = tpl.content.querySelector('cart-items');
          if (!fresh || !this.parentNode) return false;
          this.parentNode.replaceChild(fresh, this);
          return true;
        }

        __refresh() {
          if (!this.sectionId) return;
          if (this.__inflight) return;
          this.__inflight = true;
          var rows = this.querySelector('[data-cart-items-rows]');
          if (rows) rows.setAttribute('aria-busy', 'true');
          this.setAttribute('aria-busy', 'true');
          var base =
            (window.__cartItemsConfig && window.__cartItemsConfig.rootUrl) ||
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
            '/';
          if (this.__abort) this.__abort.abort();
          this.__abort = new AbortController();
          fetch(base + '?sections=' + encodeURIComponent(this.sectionId), {
            signal: this.__abort.signal
          })
            .then(function (response) {
              if (!response.ok) throw new Error('cart-items fetch failed');
              return response.json();
            })
            .then(function (data) {
              var html = data && data[this.sectionId];
              if (!html) return;
              var tpl = document.createElement('template');
              tpl.innerHTML = html.trim();
              var fresh = tpl.content.querySelector('cart-items');
              if (fresh && this.parentNode) {
                this.parentNode.replaceChild(fresh, this);
              }
            }.bind(this))
            .catch(function (error) {
              if (error && error.name !== 'AbortError') {
                window.location.reload();
              }
            })
            .then(function () {
              this.__inflight = false;
            }.bind(this));
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cart-related')) return;

    class CartRelated extends HTMLElement {
      connectedCallback() {
        if (this.__crBound) return;
        this.__crBound = true;
        this.__onCartUpdated = this.refresh.bind(this);
        document.addEventListener('cart:updated', this.__onCartUpdated);
      }

      disconnectedCallback() {
        if (!this.__crBound) return;
        this.__crBound = false;
        document.removeEventListener('cart:updated', this.__onCartUpdated);
      }

      refresh() {
        var sectionId = this.dataset.sectionId;
        if (!sectionId) return;
        var self = this;
        var token = (this.__crToken || 0) + 1;
        this.__crToken = token;

        fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (token !== self.__crToken) return;
            var html = data && data[sectionId];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('cart-related');
            if (!fresh) return;
            self.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }
    }

    customElements.define('cart-related', CartRelated);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["city-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('city-accordion')) {
    customElements.define(
      'city-accordion',
      class CityAccordion extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;

          this.addEventListener('click', (this.__onToggleClick = (event) => {
            const btn = event.target.closest('[data-city-toggle]');
            if (!btn || !this.contains(btn)) return;
            const city = btn.getAttribute('data-city-toggle');
            if (btn.getAttribute('aria-expanded') === 'true') {
              this.__collapse(city);
            } else {
              this.open(city);
            }
          }));

          /* salon-map pins publish this (both contract names on their
             side); this section owns opening the group and scrolling it
             below the sticky header. */
          document.addEventListener('salon-city:open', (this.__onCityOpen = (event) => {
            const city = event.detail && event.detail.city;
            if (!city || !this.querySelector('[data-city="' + city + '"]')) return;
            this.open(city, { scroll: true });
          }));

          /* Deep link: page.salons#wellington opens Wellington on load. */
          if (location.hash) {
            const city = decodeURIComponent(location.hash.slice(1));
            if (this.querySelector('[data-city="' + city + '"]')) {
              this.open(city, { scroll: true });
            }
          }
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.removeEventListener('click', this.__onToggleClick);
          document.removeEventListener('salon-city:open', this.__onCityOpen);
          this.__bound = false;
        }

        /* Exclusive accordion: opening one city collapses any other
           first, in the same action. */
        open(city, opts) {
          const target = this.querySelector('[data-city="' + city + '"]');
          if (!target) return;
          this.querySelectorAll('[data-city-toggle]').forEach((btn) => {
            if (btn.getAttribute('data-city-toggle') !== city && btn.getAttribute('aria-expanded') === 'true') {
              this.__collapse(btn.getAttribute('data-city-toggle'));
            }
          });
          const btn = target.querySelector('[data-city-toggle]');
          const panel = target.querySelector('.city-accordion__panel');
          if (!btn || !panel) return;
          if (btn.getAttribute('aria-expanded') !== 'true') {
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            /* Two frames so the 0fr row is committed before expanding,
               otherwise the browser skips the transition. */
            requestAnimationFrame(() => {
              requestAnimationFrame(() => panel.classList.add('is-open'));
            });
            document.dispatchEvent(
              new CustomEvent('salon-city:toggle', {
                bubbles: true,
                detail: { city: city, open: true }
              })
            );
          }
          if (opts && opts.scroll) this.__scrollTo(target);
        }

        __collapse(city) {
          const target = this.querySelector('[data-city="' + city + '"]');
          if (!target) return;
          const btn = target.querySelector('[data-city-toggle]');
          const panel = target.querySelector('.city-accordion__panel');
          if (!btn || !panel || btn.getAttribute('aria-expanded') !== 'true') return;

          btn.setAttribute('aria-expanded', 'false');
          const finish = () => {
            panel.hidden = true;
            panel.classList.remove('is-open');
          };
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            finish();
          } else {
            panel.classList.remove('is-open');
            const clip = panel.querySelector('.city-accordion__panel-clip');
            clip.addEventListener(
              'transitionend',
              (event) => {
                if (event.propertyName === 'grid-template-rows') finish();
              },
              { once: true }
            );
            /* Fallback: a skipped transition never fires transitionend. */
            setTimeout(() => {
              if (!panel.hidden) finish();
            }, 400);
          }
          document.dispatchEvent(
            new CustomEvent('salon-city:toggle', {
              bubbles: true,
              detail: { city: city, open: false }
            })
          );
        }

        __scrollTo(cityEl) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          cityEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('collection-header')) return;

    var MOBILE_QUERY = '(max-width: 749.98px)';

    customElements.define(
      'collection-header',
      class CollectionHeader extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.sectionId = this.dataset.sectionId;
          this.__onChipClick = this.__handleChipClick.bind(this);
          this.__onClearClick = this.__handleClearClick.bind(this);
          this.__onSortChange = this.__handleSortChange.bind(this);
          this.__onFiltersClick = this.__handleFiltersClick.bind(this);
          this.__onSheetClick = this.__handleSheetClick.bind(this);
          this.__onSheetKeydown = this.__handleSheetKeydown.bind(this);
          this.__onSheetScrim = this.__closeSheet.bind(this);
          this.__onFacetsChanged = this.__handleExternalChange.bind(this);
          this.__onPopState = function () { this.__fetchAndSwap(window.location.href); }.bind(this);
          this.addEventListener('click', this.__onChipClick);
          this.addEventListener('click', this.__onClearClick);
          this.addEventListener('change', this.__onSortChange);
          this.addEventListener('click', this.__onFiltersClick);
          this.addEventListener('click', this.__onSheetClick);
          document.addEventListener('keydown', this.__onSheetKeydown);
          document.addEventListener('scrim:click', this.__onSheetScrim);
          document.addEventListener('facets:changed', this.__onFacetsChanged);
          window.addEventListener('popstate', this.__onPopState);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.removeEventListener('click', this.__onChipClick);
          this.removeEventListener('click', this.__onClearClick);
          this.removeEventListener('change', this.__onSortChange);
          this.removeEventListener('click', this.__onFiltersClick);
          this.removeEventListener('click', this.__onSheetClick);
          document.removeEventListener('keydown', this.__onSheetKeydown);
          document.removeEventListener('scrim:click', this.__onSheetScrim);
          document.removeEventListener('facets:changed', this.__onFacetsChanged);
          window.removeEventListener('popstate', this.__onPopState);
        }

        __handleChipClick(event) {
          var remove = event.target.closest('[data-remove-filter]');
          if (!remove) return;
          event.preventDefault();
          this.__applyUrl(remove.getAttribute('href'));
        }

        __handleClearClick(event) {
          var clear = event.target.closest('[data-clear-filters]');
          if (!clear) return;
          event.preventDefault();
          this.__applyUrl(clear.getAttribute('href'));
        }

        __handleSortChange(event) {
          if (!event.target.matches('[data-sort-select]')) return;
          this.__applySortValue(event.target.value);
        }

        __applySortValue(value) {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          this.__applyUrl(url.toString());
        }

        __handleFiltersClick(event) {
          if (!event.target.closest('[data-filter-drawer-open]')) return;
          document.dispatchEvent(
            new CustomEvent('filter-drawer:open', { detail: { invoker: event.target.closest('[data-filter-drawer-open]') } })
          );
        }

        /* Mobile SORT BY sheet: open over the shared scrim (one scrim rule,
           raised above the drawer layer while open), close on the close
           control, the scrim or Escape, and commit a sort on option pick. */
        __handleSheetClick(event) {
          if (event.target.closest('[data-sort-sheet-open]')) {
            this.__openSheet();
            return;
          }
          if (event.target.closest('[data-sort-sheet-close]')) {
            this.__closeSheet();
            return;
          }
          var option = event.target.closest('[data-sort-sheet-option]');
          if (option) {
            var value = option.getAttribute('data-value');
            this.__closeSheet();
            this.__applySortValue(value);
          }
        }

        __sheet() {
          return this.querySelector('[data-sort-sheet]');
        }

        __openSheet() {
          var sheet = this.__sheet();
          if (!sheet || sheet.classList.contains('is-open')) return;
          if (!window.matchMedia(MOBILE_QUERY).matches) return;
          this.__sheetInvoker = document.activeElement;
          sheet.classList.add('is-open');
          sheet.removeAttribute('aria-hidden');
          var scrim = document.querySelector('[data-scrim]');
          if (scrim) {
            scrim.style.setProperty('--scrim-top', '0px');
            scrim.style.setProperty('--scrim-z', '60');
            scrim.classList.add('is-open');
          }
          var panel = sheet.querySelector('.collection-header__sort-sheet-panel');
          if (panel && typeof panel.focus === 'function') panel.focus();
        }

        __closeSheet() {
          var sheet = this.__sheet();
          if (!sheet || !sheet.classList.contains('is-open')) return;
          sheet.classList.remove('is-open');
          sheet.setAttribute('aria-hidden', 'true');
          var scrim = document.querySelector('[data-scrim]');
          if (scrim) {
            scrim.classList.remove('is-open');
            scrim.style.removeProperty('--scrim-top');
            scrim.style.removeProperty('--scrim-z');
          }
          if (this.__sheetInvoker && typeof this.__sheetInvoker.focus === 'function') {
            this.__sheetInvoker.focus();
          }
          this.__sheetInvoker = null;
        }

        __handleSheetKeydown(event) {
          var sheet = this.__sheet();
          if (!sheet || !sheet.classList.contains('is-open')) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.__closeSheet();
            return;
          }
          if (event.key !== 'Tab') return;
          var focusables = sheet.querySelectorAll('button');
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        __handleExternalChange(event) {
          if (!event.detail || !event.detail.url) return;
          if (event.detail.source === this) return;
          this.__fetchAndSwap(event.detail.url);
        }

        __applyUrl(url) {
          history.pushState({}, '', url);
          this.__fetchAndSwap(url);
          document.dispatchEvent(
            new CustomEvent('facets:changed', { detail: { url: url, source: this } })
          );
        }

        __fetchAndSwap(url) {
          if (!this.sectionId) return;
          if (this.__abort) this.__abort.abort();
          this.__abort = new AbortController();
          var fetchUrl = new URL(url, window.location.origin);
          fetchUrl.searchParams.set('section_id', this.sectionId);
          fetch(fetchUrl.toString(), { signal: this.__abort.signal })
            .then(function (response) {
              if (!response.ok) throw new Error('collection-header fetch failed');
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-collection-header]');
              if (fresh) {
                /* A morph landing while the sheet is open would replace the
                   sheet with a closed copy and orphan the raised scrim. */
                this.__closeSheet();
                this.innerHTML = fresh.innerHTML;
              }
            }.bind(this))
            .catch(function (error) {
              if (error && error.name !== 'AbortError') {
                window.location.href = url;
              }
            });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__contactForm) return;
    window.__contactForm = true;

    document.addEventListener('DOMContentLoaded', function () {
      var heading = document.querySelector('[data-contact-success-heading]');
      if (heading) heading.focus();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.contact-form__form');
      if (!form || event.defaultPrevented) return;

      form.classList.add('is-submitting');
      var button = form.querySelector('[data-contact-submit]');
      if (button) {
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Footer mobile accordions - single delegated listener on document (swap-safe
  // per the modern JS architecture), gated to <=750px. The columns' disclosure
  // behaviour is class-driven on the column wrapper; desktop makes the whole
  // behaviour inert via CSS (cursor default, panels always visible), and the
  // listener exits early above the breakpoint. Binding is delegated, so the
  // guard stays set across theme-editor section reloads - no listener rebinding.
  (function () {
    if (window.__footerAccordionInit) return;
    window.__footerAccordionInit = true;

    var mq = window.matchMedia('(max-width: 750px)');

    document.addEventListener('click', function (event) {
      if (!mq.matches) return;
      var header = event.target.closest('[data-footer-toggle]');
      if (!header) return;
      var column = header.closest('[data-footer-column]');
      if (!column) return;
      var panel = column.querySelector('[data-footer-panel]');
      if (!panel) return;
      var open = column.classList.toggle('footer__column--open');
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Restore static state when crossing to desktop
    mq.addEventListener('change', function (event) {
      if (event.matches) return;
      document.querySelectorAll('[data-footer-column]').forEach(function (column) {
        column.classList.remove('footer__column--open');
      });
      // Upgrade swaps the button for a plain h3 and strips aria-expanded +
      // aria-controls - desktop headings are static (checklist 15).
      window.__footerUpgradeAccordions();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-buy"]) return;
  try {
    
  (function () {
    if (window.__giftCardBuyInit) return;
    window.__giftCardBuyInit = true;

    /* Computed ATC label: the initial label is rendered server-side from
       the selected variant (money_without_trailing_zeros — the "$75"
       shape); on a denomination change the snippet's variant-change event
       retypes it from the live radio price. The label SHAPE ships whole
       in data-gift-card-atc-amount-format ("$__AMOUNT__", the money
       pipeline's own shape) so the runtime never re-types it; the amount
       is never a typed string — it is the radio's live data-variant-price
       through the same "$" + dollars idiom the chips render. */
    var AMOUNT_FORMAT = '$__AMOUNT__';
    var formatEl = document.querySelector('[data-gift-card-atc-amount-format]');
    if (formatEl) {
      AMOUNT_FORMAT = formatEl.getAttribute('data-format') || AMOUNT_FORMAT;
    }

    function formatMoney(cents) {
      var amount = Number(cents);
      if (isNaN(amount)) return '';
      var dollars = amount / 100;
      /* Replace on __AMOUNT__ only — the leading "$" of the format shape
         ($__AMOUNT__) must survive the swap, so matching "$__AMOUNT__"
         consumes the currency mark and the retyped label loses it. */
      return AMOUNT_FORMAT.replace('__AMOUNT__', dollars % 1 === 0 ? String(dollars) : dollars.toFixed(2));
    }

    document.addEventListener('gift-card-form:variant-change', function (event) {
      var root = event.target instanceof Element ? event.target.closest('[data-gift-card-buy]') : null;
      if (!root) return;
      var btn = root.querySelector('[data-gift-card-atc]');
      var label = btn ? btn.querySelector('.button__label') : null;
      if (!label || !event.detail || typeof event.detail.price === 'undefined') return;
      /* The amount template (data-gift-card-atc-template) carries the
         full label with the __AMOUNT__ placeholder — swap the amount in
         so the Translations Editor copy stays authoritative; when the
         merged key carries no placeholder (a translation dropped it), the
         amount alone is retyped so the figure never goes stale. */
      var amount = formatMoney(event.detail.price);
      var tplEl = document.querySelector('[data-gift-card-atc-template]');
      var tpl = tplEl ? tplEl.textContent.trim() : '';
      try {
        tpl = JSON.parse(tpl);
      } catch (err) {
        /* Raw string when unquoted. */
      }
      if (typeof tpl === 'string' && tpl.indexOf('__AMOUNT__') !== -1) {
        label.textContent = tpl.replace('__AMOUNT__', amount);
      } else if (typeof tpl === 'string') {
        label.textContent = tpl;
      } else {
        label.textContent = amount;
      }
    });

    /* The add: AJAX through routes.cart_add_url.js (HTML routes are not
       JSON endpoints — the cart-routes gotcha) with the whole form body so
       the recipient properties ride the post; native-submit fallback. */
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form.gift-card-buy__form');
      if (!form) return;
      var root = form.closest('[data-gift-card-buy]');
      if (!root) return;

      var routesEl = root.querySelector('[data-gift-card-routes]');
      var cartAdd = routesEl ? routesEl.getAttribute('data-cart-add') : '/cart/add.js';
      if (!cartAdd) return;

      event.preventDefault();
      var btn = form.querySelector('[data-gift-card-atc]');
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      }

      var body = new URLSearchParams(new FormData(form));
      fetch(cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'gift-card-buy' } }));
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { invoker: btn } }));
        })
        .catch(function () {
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__headerBooted) return;
    window.__headerBooted = true;

    /* The clone hard-coded the bar heights (73/98 + a 32px announcement); the
       delta measures the rendered bars instead, so a merchant logo or font
       swap cannot desync the overlays that anchor to --header-height. */
    function measure() {
      var header = document.querySelector('[data-header]');
      if (!header) return;
      /* Must track the CSS bar swap exactly - it decides which bar's height
         is published as --header-height for the overlays to anchor to. */
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      var height = 0;
      if (isDesktop) {
        var bar = header.querySelector('.header__main-bar');
        var strip = header.querySelector('.header__category-strip');
        if (bar) height += bar.offsetHeight;
        if (strip) height += strip.offsetHeight;
      } else {
        var mobileBar = header.querySelector('.header__mobile-bar');
        var searchRow = header.querySelector('.header__search-row');
        if (mobileBar) height += mobileBar.offsetHeight;
        if (searchRow) height += searchRow.offsetHeight;
      }
      var announce = document.querySelector('.announcement-bar');
      var announcementHeight = announce ? announce.offsetHeight : 0;
      document.documentElement.style.setProperty(
        '--header-height',
        (height + announcementHeight) + 'px'
      );
      /* The header alone, without the announcement band: once the header
         sticks, the announcement has already scrolled away, so this is the
         real amount of viewport it covers. Anything that has to clear a
         stuck header (sticky columns, anchor targets) needs this, not
         --header-height. */
      document.documentElement.style.setProperty(
        '--header-sticky-height',
        height + 'px'
      );
    }

    function initHeader(root) {
      var header = root && root.querySelector ? root.querySelector('[data-header]') : null;
      if (!header) return;
      measure();

      var desktopInput = header.querySelector('[data-header-search-input]');
      if (desktopInput && !desktopInput.__headerHooked) {
        desktopInput.__headerHooked = true;
        desktopInput.addEventListener('focus', function () {
          document.dispatchEvent(new CustomEvent('header:search:open'));
        });
      }

      /* The mobile field is a real input, so it announces on focus the same
         way the desktop field does -- a click listener fired before focus and
         raced the dropdown open. */
      var pill = header.querySelector('[data-header-search-trigger]');
      if (pill && !pill.__headerHooked) {
        pill.__headerHooked = true;
        pill.addEventListener('focus', function () {
          document.dispatchEvent(new CustomEvent('header:search:open'));
        });
      }

      var bags = header.querySelectorAll('[data-cart-open]');
      for (var i = 0; i < bags.length; i++) {
        var bag = bags[i];
        if (bag.__headerHooked) continue;
        bag.__headerHooked = true;
        /* One overlay at a time: header:cart:open closes the mega menu, the
           nav drawer and instant search; the cart-flyout element opens on
           the same click via its own [data-cart-open] delegate. */
        bag.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('header:cart:open'));
        });
      }

      /* Checklist 14: the burger's aria-expanded must flip with the drawer.
         The drawer owns its own panel state (data-open/aria-hidden) and only
         knows its opener through __invoker for focus return, so the header
         syncs its own burger off the drawer's published events. */
      var burger = header.querySelector('[data-nav-drawer-open]');
      if (burger) {
        document.addEventListener('drawer:open', function () {
          burger.setAttribute('aria-expanded', 'true');
        });
        document.addEventListener('drawer:close', function () {
          burger.setAttribute('aria-expanded', 'false');
        });
      }
    }

    initHeader(document);
    document.addEventListener('shopify:section:load', function (event) {
      initHeader(event.target);
      measure();
    });
    window.addEventListener('resize', measure);
    var announce = document.querySelector('.announcement-bar');
    if (announce && 'ResizeObserver' in window) {
      new ResizeObserver(measure).observe(announce);
    }

    /* Custom search clear (flags 56): shows once the field has text; click
       empties the field, re-fires input so instant search falls back to
       its suggestions + default rail, and returns focus. */
    document.addEventListener('input', function (event) {
      var t = event.target;
      if (!t || !t.matches) return;
      if (!t.matches('[data-header-search-input], [data-header-search-trigger]')) return;
      var btn = t.parentElement.querySelector('[data-header-search-clear]');
      if (btn) btn.hidden = t.value.length === 0;
    });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-header-search-clear]') : null;
      if (!btn) return;
      var input = btn.parentElement.querySelector('input[type="search"]');
      if (!input) return;
      /* The drawn open row shows this close beside an EMPTY field, so it is
         now visible whenever the search is open. On an empty field there is
         nothing to clear, which would make it a dead tap - dismiss the
         search instead (instant-search listens for `search:close`). */
      if (input.value.length === 0) {
        document.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));
        return;
      }
      input.value = '';
      btn.hidden = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-banner')) {
    class HeroBanner extends HTMLElement {
      constructor() {
        super();
        this.__bound = false;
        this.__timer = null;
        this.__activeIndex = 0;
        this.__touchX = 0;
        this.__touchY = 0;
        this.__paused = false;
        /* Set for good once a bar or a swipe is used - an explicit choice
           must not be overwritten by the timer (WCAG 2.2.2 "stop"). */
        this.__halted = false;
      }

      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__slides = Array.from(this.querySelectorAll('.hero__slide'));
        this.__bars = Array.from(this.querySelectorAll('[data-hero-bars] .hero__bar'));
        this.__live = this.querySelector('[data-hero-live]');
        this.__banner = this.querySelector('.hero__banner');
        this.__autoplay = this.dataset.autoplay === 'true';
        this.__dwell = parseInt(this.dataset.dwell, 10) || 5000;

        if (this.__slides.length < 2) return;

        /* Swipe is a mobile-only affordance (decision #13): the media query
           is read at touch time so pointer dragging on desktop never moves
           the slides. */
        this.__mobile = window.matchMedia('(max-width: 749px)');
        this.__onTouchStart = (event) => {
          this.__touchX = event.touches[0].clientX;
          this.__touchY = event.touches[0].clientY;
        };
        this.__onTouchEnd = (event) => {
          if (!this.__mobile.matches) return;
          const dx = event.changedTouches[0].clientX - this.__touchX;
          const dy = event.changedTouches[0].clientY - this.__touchY;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          /* A recognised swipe must not also fire the click the browser
             synthesises on release. With banner_link_url set the whole
             banner is a link, so without this a swipe would change the
             slide AND navigate away; the same release could already land
             on a CTA button under the finger. Only reached once a real
             horizontal swipe has been recognised, so a tap - on a CTA, a
             bar or the banner link - is untouched. */
          if (event.cancelable) event.preventDefault();
          if (dx < 0) {
            this.__choose((this.__activeIndex + 1) % this.__slides.length);
          } else {
            this.__choose((this.__activeIndex - 1 + this.__slides.length) % this.__slides.length);
          }
        };

        this.__bars.forEach((bar) => {
          bar.addEventListener('click', () => {
            this.__choose(parseInt(bar.dataset.heroBar, 10) || 0);
          });
        });
        this.__banner.addEventListener('touchstart', this.__onTouchStart, { passive: true });
        this.__banner.addEventListener('touchend', this.__onTouchEnd);

        /* Rotation (Synergy port, ticket 20447262) - only wired when the
           merchant leaves autoplay on. */
        if (!this.__autoplay) return;

        this.__reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.__onVisibility = () => this.__sync();
        this.__onMotionChange = () => this.__sync();
        this.__onPointerEnter = () => {
          this.__paused = true;
          this.__sync();
        };
        this.__onPointerLeave = () => {
          this.__paused = false;
          this.__sync();
        };
        this.__onFocusIn = () => {
          this.__paused = true;
          this.__sync();
        };
        this.__onFocusOut = (event) => {
          /* Moving between the bars keeps focus inside - stay paused. */
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;
          this.__paused = false;
          this.__sync();
        };

        this.__reducedMotion.addEventListener('change', this.__onMotionChange);
        document.addEventListener('visibilitychange', this.__onVisibility);
        this.addEventListener('mouseenter', this.__onPointerEnter);
        this.addEventListener('mouseleave', this.__onPointerLeave);
        this.addEventListener('focusin', this.__onFocusIn);
        this.addEventListener('focusout', this.__onFocusOut);

        this.__sync();
      }

      disconnectedCallback() {
        this.__stop();
        if (this.__banner) {
          this.__banner.removeEventListener('touchstart', this.__onTouchStart);
          this.__banner.removeEventListener('touchend', this.__onTouchEnd);
        }
        if (this.__reducedMotion) {
          this.__reducedMotion.removeEventListener('change', this.__onMotionChange);
          document.removeEventListener('visibilitychange', this.__onVisibility);
          this.removeEventListener('mouseenter', this.__onPointerEnter);
          this.removeEventListener('mouseleave', this.__onPointerLeave);
          this.removeEventListener('focusin', this.__onFocusIn);
          this.removeEventListener('focusout', this.__onFocusOut);
        }
        this.__bound = false;
      }

      /* Rotation runs at every breakpoint, only with autoplay on, only with
         motion allowed, only while the tab is visible, only while the
         shopper is not hovering or keyboarding through the banner, and only
         until a bar or a swipe is used. */
      __sync() {
        const shouldRotate =
          this.__autoplay &&
          !this.__halted &&
          !this.__paused &&
          !this.__reducedMotion.matches &&
          !document.hidden;
        if (shouldRotate) {
          this.__start();
        } else {
          this.__stop();
        }
      }

      __start() {
        if (this.__timer) return;
        this.__timer = setInterval(() => this.__advance(), this.__dwell);
      }

      __stop() {
        if (this.__timer) {
          clearInterval(this.__timer);
          this.__timer = null;
        }
      }

      __advance() {
        this.__setActive((this.__activeIndex + 1) % this.__slides.length);
      }

      /* A shopper's own pick (bar or swipe) halts rotation for good. */
      __choose(index) {
        this.__halted = true;
        this.__stop();
        this.__setActive(index);
      }

      __setActive(index) {
        this.__activeIndex = index;
        this.__slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });
        this.__bars.forEach((bar, barIndex) => {
          const active = barIndex === index;
          bar.classList.toggle('is-active', active);
          if (active) {
            bar.setAttribute('aria-current', 'true');
          } else {
            bar.removeAttribute('aria-current');
          }
        });
        if (this.__live) {
          const strings = window.__heroBannerStrings;
          if (strings && strings.liveTemplate) {
            this.__live.textContent = String(strings.liveTemplate)
              .replace('@i', String(this.__activeIndex + 1))
              .replace('@y', String(this.__slides.length));
          }
        }
      }
    }
    customElements.define('hero-banner', HeroBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muk-stockist-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mukForm) return;
    window.__mukForm = true;
 
    // Require at least one Muk range checkbox.
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.muk-form .b2b-form__form');
      if (!form) return;
      var group = form.querySelector('[data-muk-ranges]');
      if (!group) return;
      var ticked = group.querySelector('input[type="checkbox"]:checked');
      var error = group.querySelector('.muk-form__ranges-error');
      if (!ticked) {
        event.preventDefault();
        if (error) error.hidden = false;
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (error) {
        error.hidden = true;
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-in"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('new-in-carousel')) return;

    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

    class NewInCarousel extends HTMLElement {
      connectedCallback() {
        if (this.__niBound) return;
        this.__niBound = true;

        this.__rail = this.querySelector('[data-new-in-rail]');
        this.__arrows = this.querySelector('.section-header__arrows');
        this.__prev = this.querySelector('[data-carousel-prev]');
        this.__next = this.querySelector('[data-carousel-next]');

        if (!this.__rail) return;

        this.__onScroll = function () {
          window.requestAnimationFrame(this.update.bind(this));
        }.bind(this);
        this.__onResize = this.update.bind(this);

        this.__rail.addEventListener('scroll', this.__onScroll, { passive: true });
        window.addEventListener('resize', this.__onResize, { passive: true });

        /* A window resize listener alone is not enough: update() must also
           run on the rail's first real layout and on every later size
           change (images arriving, editor re-renders) or the arrows show
           enabled over a rail with nothing to scroll - the defect the
           product-carousel element fixed with an observer (QA 2026-09-02). */
        if (window.ResizeObserver) {
          this.__ro = new ResizeObserver(this.__onResize);
          this.__ro.observe(this.__rail);
        }

        this.update();
      }

      disconnectedCallback() {
        if (!this.__niBound) return;
        this.__niBound = false;
        if (this.__rail && this.__onScroll) this.__rail.removeEventListener('scroll', this.__onScroll);
        window.removeEventListener('resize', this.__onResize);
        if (this.__ro) { this.__ro.disconnect(); this.__ro = null; }
      }

      update() {
        if (!this.__rail) return;
        var max = this.__rail.scrollWidth - this.__rail.clientWidth;

        /* No overflow (fewer cards than the viewport holds): both arrows
           hide and disable - the component-17 empty-state rule. The
           [hidden] guard needs the section CSS override too (the snippet's
           author display beats the UA hidden rule), but the disabled
           state keeps the behaviour honest on its own. */
        if (max <= 1) {
          if (this.__arrows) this.__arrows.hidden = true;
          if (this.__prev) this.__prev.disabled = true;
          if (this.__next) this.__next.disabled = true;
          this.__rail.removeAttribute('data-at-start');
          this.__rail.removeAttribute('data-at-end');
          return;
        }

        if (this.__arrows) this.__arrows.hidden = false;

        var atStart = this.__rail.scrollLeft <= 1;
        var atEnd = this.__rail.scrollLeft >= max - 1;
        if (atStart) {
          this.__rail.setAttribute('data-at-start', '');
        } else {
          this.__rail.removeAttribute('data-at-start');
        }
        if (atEnd) {
          this.__rail.setAttribute('data-at-end', '');
        } else {
          this.__rail.removeAttribute('data-at-end');
        }

        if (this.__prev) this.__prev.disabled = atStart;
        if (this.__next) this.__next.disabled = atEnd;
      }

      /* One card + one gap (checklist 13): measured off the real items
         (media frame included) so a breakpoint change never desyncs the
         step. The rail item copy of the media frame is display:none on
         mobile (the frame renders above the rail there), and a hidden
         element's rect is all zeros - so only items that are actually
         rendered take part in the measure. */
      stepSize() {
        var items = [];
        var all = this.__rail.querySelectorAll('.new-in__item');
        for (var i = 0; i < all.length; i++) {
          if (all[i].offsetParent !== null) items.push(all[i]);
        }
        if (items.length < 2) {
          if (items.length === 1) return items[0].getBoundingClientRect().width;
          return this.__rail.clientWidth;
        }
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      }
    }
    customElements.define('new-in-carousel', NewInCarousel);

    /* Arrow driving is delegated at document level exactly once (one
       owner per trigger) so Section Rendering editor swaps never
       double-bind. Scoped to this element root: bestsellers-rail and
       product-carousel bind the same data-carousel hooks to their own
       roots and ignore foreign arrows, and this handler ignores theirs
       in turn. */
    if (!window.__newInCarouselArrowsInit) {
      window.__newInCarouselArrowsInit = true;

      document.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-carousel-prev]');
        var next = event.target.closest('[data-carousel-next]');
        if (!prev && !next) return;

        var root = (prev || next).closest('new-in-carousel');
        if (!root) return;
        var rail = root.querySelector('[data-new-in-rail]');
        if (!rail) return;

        var step = root.stepSize();
        if (step <= 0) return;

        rail.scrollBy({
          left: next ? step : -step,
          behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  if (!customElements.get('password-form')) {
    class PasswordForm extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.boundSubmit = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.boundSubmit);
      }

      disconnectedCallback() {
        if (this.form && this.boundSubmit) {
          this.form.removeEventListener('submit', this.boundSubmit);
        }
        this.dataset.bound = '';
      }

      handleSubmit(event) {
        if (this.dataset.busy === 'true') return;
        const submit = this.querySelector('[data-password-submit]');
        if (!submit) return;
        this.dataset.busy = 'true';
        submit.classList.add('is-loading');
        submit.setAttribute('aria-busy', 'true');
      }
    }

    customElements.define('password-form', PasswordForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-reviews')) {
    class PdpReviews extends HTMLElement {
      constructor() {
        super();
        this.__bound = false;
      }

      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__trigger = this.querySelector('[data-pdp-reviews-trigger]');

        this.__onTriggerClick = () => {
          this.__trigger.setAttribute('aria-expanded', 'true');
          document.dispatchEvent(
            new CustomEvent('review:write-open', {
              bubbles: true,
              detail: { source: 'pdp-reviews' }
            })
          );
        };

        this.__onDrawerClose = () => {
          if (this.__trigger) this.__trigger.setAttribute('aria-expanded', 'false');
        };

        this.__onSectionLoad = (event) => {
          if (event.target.contains(this) && this.__trigger) {
            this.__trigger.setAttribute('aria-expanded', 'false');
          }
        };

        if (this.__trigger) this.__trigger.addEventListener('click', this.__onTriggerClick);
        document.addEventListener('review:write-close', this.__onDrawerClose);
        document.addEventListener('shopify:section:load', this.__onSectionLoad);
      }

      disconnectedCallback() {
        if (this.__trigger) this.__trigger.removeEventListener('click', this.__onTriggerClick);
        document.removeEventListener('review:write-close', this.__onDrawerClose);
        document.removeEventListener('shopify:section:load', this.__onSectionLoad);
        this.__bound = false;
      }
    }
    customElements.define('pdp-reviews', PdpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('product-carousel')) return;

    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

    class ProductCarousel extends HTMLElement {
      connectedCallback() {
        if (this.__pcBound) return;
        this.__pcBound = true;

        this.__track = this.querySelector('[data-carousel-track]');
        this.__prev = this.querySelector('[data-carousel-prev]');
        this.__next = this.querySelector('[data-carousel-next]');

        /* Related-source hosts ask the store for its real product
           recommendations and upgrade themselves; a pending shell has no
           track at all and exists only for that answer. */
        this.requestRecommendations();

        if (!this.__track || !this.__prev || !this.__next) return;

        this.__onScroll = this.onScroll.bind(this);
        this.__onResize = this.onResize.bind(this);

        this.__track.addEventListener('scroll', this.__onScroll, { passive: true });
        window.addEventListener('resize', this.__onResize, { passive: true });

        /* A window resize listener alone was not enough: update() ran once on
           connect, and if the track had no measured width yet (upgraded before
           layout, or inside a display:none ancestor) scrollWidth - clientWidth
           came out large, so the arrows showed and were never recomputed - an
           enabled next arrow over a rail with nothing to scroll. Observing the
           track re-runs the check on its first real layout and on every later
           size change, including product images arriving (QA 2026-09-02). */
        if (window.ResizeObserver) {
          this.__ro = new ResizeObserver(this.__onResize);
          this.__ro.observe(this.__track);
        }

        this.onResize();
      }

      disconnectedCallback() {
        if (!this.__pcBound) return;
        this.__pcBound = false;
        if (this.__track) this.__track.removeEventListener('scroll', this.__onScroll);
        window.removeEventListener('resize', this.__onResize);
        if (this.__ro) { this.__ro.disconnect(); this.__ro = null; }
      }

      /* Product Recommendations + Section Rendering API. Shopify only
         fills recommendations.products on its own request, so the
         element fetches its own markup back and swaps the cards in.
         Fetched on connect, not on intersection: a pending shell is
         display:none and so has no box for an observer to fire on. */
      requestRecommendations() {
        var url = this.dataset.recommendationsUrl;
        if (!url) return;
        if (this.__pcRecommendRequested) return;
        this.__pcRecommendRequested = true;

        var self = this;

        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('product recommendations fetch failed');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('product-carousel');
            if (!fresh) return;

            /* Only a render that actually carried recommendations
               replaces what the server put on screen - otherwise the
               collection fallback rail (or the hidden shell) stands. */
            if (fresh.dataset.source !== 'related') return;
            if (!fresh.querySelector('[data-carousel-track]')) return;

            self.swapIn(fresh);
          })
          .catch(function () {
            /* Silent: the server-rendered fallback is the contract. */
          });
      }

      swapIn(fresh) {
        /* Release the listeners before the nodes they point at go away,
           then re-upgrade against the fresh markup (the flag reset keeps
           connectedCallback from short-circuiting). */
        this.disconnectedCallback();

        this.innerHTML = fresh.innerHTML;

        var label = fresh.getAttribute('aria-labelledby');
        if (label) this.setAttribute('aria-labelledby', label);
        this.dataset.source = 'related';
        this.removeAttribute('data-recommendations-url');
        this.hidden = false;

        this.connectedCallback();
      }

      visibleCount() {
        var items = this.__track.querySelectorAll('[data-carousel-item]');
        if (items.length === 0) return 1;
        var gap = parseFloat(getComputedStyle(this.__track).columnGap) || 0;
        var trackWidth = this.__track.clientWidth;
        var first = items[0].getBoundingClientRect().width;
        if (first <= 0) return 1;
        return Math.max(1, Math.round((trackWidth + gap) / (first + gap)));
      }

      stepSize() {
        var items = this.__track.querySelectorAll('[data-carousel-item]');
        if (items.length < 2) {
          if (items.length === 1) return items[0].getBoundingClientRect().width;
          return this.__track.clientWidth;
        }
        var gap = parseFloat(getComputedStyle(this.__track).columnGap) || 0;
        return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      }

      scrollByView() {
        var visible = this.visibleCount();
        var gap = parseFloat(getComputedStyle(this.__track).columnGap) || 0;
        return (this.stepSize() + gap) * visible;
      }

      onScroll() {
        window.requestAnimationFrame(this.update.bind(this));
      }

      /* Correctness must not depend on a frame callback: requestAnimationFrame
         is suspended in a hidden or backgrounded tab, so an rAF-only update
         left the arrows in their server-rendered state (prev disabled, next
         enabled) on any page that loaded while hidden - a prerendered tab, a
         restored session, a background load. Update synchronously, and keep
         rAF only for the high-frequency scroll path (QA 2026-09-02). */
      onResize() {
        this.update();
      }

      update() {
        var max = this.__track.scrollWidth - this.__track.clientWidth;

        /* Few-products state: nothing to scroll - hide both arrows and
           leave the track static. Threshold keeps a sub-pixel scrollbar
           overhang from counting as scrollable. Both are disabled as
           well as hidden so the state stays honest if the CSS
           [hidden] guard is ever lost: the server ships prev disabled
           and next enabled, and an enabled-looking next that cannot
           scroll is the defect this branch used to leave behind. */
        if (max <= 1) {
          this.__prev.disabled = true;
          this.__next.disabled = true;
          this.__prev.hidden = true;
          this.__next.hidden = true;
          return;
        }

        this.__prev.hidden = false;
        this.__next.hidden = false;

        var atStart = this.__track.scrollLeft <= 1;
        var atEnd = this.__track.scrollLeft >= max - 1;

        this.__prev.disabled = atStart;
        this.__next.disabled = atEnd;
      }
    }

    customElements.define('product-carousel', ProductCarousel);

    /* Arrow driving is delegated at document level exactly once (one
       owner per trigger) so Section Rendering swaps never double-bind
       and arrows keep working after shopify:section:load re-upgrades. */
    if (!window.__productCarouselArrowsInit) {
      window.__productCarouselArrowsInit = true;

      document.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-carousel-prev]');
        var next = event.target.closest('[data-carousel-next]');
        if (!prev && !next) return;

        var root = (prev || next).closest('product-carousel');
        var track = root && root.querySelector('[data-carousel-track]');
        if (!track || !root) return;

        var distance = root.scrollByView();
        if (distance <= 0) return;

        track.scrollBy({
          left: prev ? -distance : distance,
          behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"]) return;
  try {
    
  (function () {
    if (customElements.get('product-grid')) return;

    customElements.define(
      'product-grid',
      class ProductGrid extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;
          this.sectionId = this.dataset.sectionId;
          this.results = this.querySelector('[data-results]');
          this.list = this.querySelector('[data-grid-list]');
          this.loadMore = this.querySelector('[data-load-more]');
          this.__onClick = this.__handleClick.bind(this);
          this.__onFacetsChanged = this.__handleExternalChange.bind(this);
          this.__onPopState = function () {
            this.__fetchAndSwap(window.location.href);
          }.bind(this);
          this.addEventListener('click', this.__onClick);
          document.addEventListener('facets:changed', this.__onFacetsChanged);
          window.addEventListener('popstate', this.__onPopState);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.__bound = false;
          this.removeEventListener('click', this.__onClick);
          document.removeEventListener('facets:changed', this.__onFacetsChanged);
          window.removeEventListener('popstate', this.__onPopState);
        }

        __handleClick(event) {
          var trigger = event.target.closest('[data-load-more]');
          if (!trigger) return;
          event.preventDefault();
          this.__loadMore(trigger);
        }

        __loadMore(trigger) {
          var url = trigger.getAttribute('href');
          if (!url) return;
          var section = this;
          section.setAttribute('data-loading', 'true');
          if (this.results) this.results.setAttribute('aria-busy', 'true');
          trigger.setAttribute('aria-disabled', 'true');
          trigger.classList.add('is-loading');
          trigger.setAttribute('aria-busy', 'true');

          section
            .__fetchSection(url)
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-results]');
              if (!fresh) throw new Error('no results in response');

              var freshItems = fresh.querySelectorAll('[data-grid-list] > li');
              var list = section.querySelector('[data-grid-list]');
              var firstNew = null;
              if (list && freshItems.length) {
                for (var i = 0; i < freshItems.length; i++) {
                  var node = document.importNode(freshItems[i], true);
                  if (!firstNew) firstNew = node.querySelector('a[href]');
                  list.appendChild(node);
                }
              }

              section.__syncMeta(fresh);
              section.__swapLoadMore(fresh);

              var shown = section.__shownCount();
              var total = section.__totalCount();
              history.replaceState({}, '', section.__pageUrl(url));

              document.dispatchEvent(
                new CustomEvent('grid:updated', {
                  detail: { shown: shown, total: total }
                })
              );

              if (firstNew && typeof firstNew.focus === 'function') firstNew.focus();
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              window.location.href = url;
            })
            .then(function () {
              section.removeAttribute('data-loading');
              if (section.results) section.results.removeAttribute('aria-busy');
              var next = section.querySelector('[data-load-more]');
              if (next && next.getAttribute('aria-disabled') !== 'true') {
                next.classList.remove('is-loading');
                next.removeAttribute('aria-busy');
              }
            });
        }

        __handleExternalChange(event) {
          if (!event.detail || !event.detail.url) return;
          this.__fetchAndSwap(event.detail.url);
        }

        __fetchAndSwap(url) {
          var section = this;
          if (this.__abort) this.__abort.abort();
          this.__abort = new AbortController();
          if (this.results) this.results.setAttribute('aria-busy', 'true');
          if (this.list) this.list.setAttribute('aria-busy', 'true');

          this.__fetchSection(url)
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-results]');
              if (!fresh) throw new Error('no results in response');
              if (section.results) section.results.innerHTML = fresh.innerHTML;

              section.__syncMeta(fresh);
              section.__swapLoadMore(fresh);

              document.dispatchEvent(
                new CustomEvent('grid:updated', {
                  detail: {
                    shown: section.__shownCount(),
                    total: section.__totalCount()
                  }
                })
              );
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              window.location.href = url;
            })
            .then(function () {
              if (section.results) section.results.removeAttribute('aria-busy');
              if (section.list && section.list.isConnected) {
                section.list.removeAttribute('aria-busy');
              } else {
                section.list = section.querySelector('[data-grid-list]');
                if (section.list) section.list.removeAttribute('aria-busy');
              }
            });
        }

        __fetchSection(url) {
          var sectionId = this.sectionId;
          if (!sectionId) return Promise.reject(new Error('no section id'));
          var controller = new AbortController();
          if (this.__abort) this.__abort.abort();
          this.__abort = controller;
          var fetchUrl = new URL(url, window.location.origin);
          fetchUrl.searchParams.set('section_id', sectionId);
          return fetch(fetchUrl.toString(), { signal: controller.signal }).then(function (
            response
          ) {
            if (!response.ok) throw new Error('product-grid fetch failed');
            return response.text();
          });
        }

        __swapLoadMore(fresh) {
          var freshBlock = fresh.querySelector('[data-pagination]');
          var current = this.querySelector('[data-pagination]');
          /* HBO one-label pagination: the block is always present while
             total > 0 (count-only when nothing more loads). The append path
             still covers a current block that was somehow absent - import
             the fresh block so the count stays honest. */
          if (!current && freshBlock) {
            this.results.appendChild(document.importNode(freshBlock, true));
            this.loadMore = this.querySelector('[data-load-more]');
            return;
          }
          if (current && freshBlock) {
            current.innerHTML = freshBlock.innerHTML;
          } else if (current && !freshBlock) {
            current.remove();
          }
        }

        __syncMeta(fresh) {
          /* The pagination block's count label carries the progress now
             (snippet delta 5 Sep) - no [data-progress-fill] exists to sync. */
        }

        __shownCount() {
          var list = this.querySelector('[data-grid-list]');
          return list ? list.querySelectorAll('li').length : 0;
        }

        __totalCount() {
          var count = this.querySelector('[data-total]');
          if (count) return parseInt(count.getAttribute('data-total'), 10) || 0;
          return this.__shownCount();
        }

        __pageUrl(url) {
          var resolved = new URL(url, window.location.origin);
          var here = new URL(window.location.href);
          here.searchParams.set('page', resolved.searchParams.get('page') || '1');
          return here.pathname + here.search + here.hash;
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-carousel')) {
    class ReviewsCarousel extends HTMLElement {
      constructor() {
        super();
        this.__bound = false;
        this.__index = 0;
        this.__timer = null;
        this.__pointer = null;
      }

      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__viewport = this.querySelector('.reviews-home__viewport');
        this.__slides = Array.from(this.querySelectorAll('.reviews-home__slide'));
        this.__buttons = Array.from(this.querySelectorAll('.reviews-home__page'));
        this.__live = this.querySelector('[data-reviews-live]');
        this.__nav = this.querySelector('.reviews-home__pagination');
        if (!this.__slides.length) return;

        this.__index = parseInt(this.dataset.activeIndex, 10) || 0;

        this.__onPageClick = (event) => {
          const button = event.target.closest('.reviews-home__page');
          if (button) this.__setActive(parseInt(button.dataset.index, 10), false);
        };
        this.__onPointerDown = (event) => {
          this.__pointer = { x: event.clientX, y: event.clientY };
        };
        this.__onPointerUp = (event) => {
          if (!this.__pointer) return;
          const dx = event.clientX - this.__pointer.x;
          const dy = event.clientY - this.__pointer.y;
          this.__pointer = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          this.__setActive(this.__index + (dx < 0 ? 1 : -1), true);
        };
        this.__onSectionLoad = (event) => {
          if (event.target.contains(this)) this.__setActive(0, false);
        };

        if (this.__nav) this.__nav.addEventListener('click', this.__onPageClick);
        this.__viewport.addEventListener('pointerdown', this.__onPointerDown);
        this.__viewport.addEventListener('pointerup', this.__onPointerUp);
        document.addEventListener('shopify:section:load', this.__onSectionLoad);
      }

      disconnectedCallback() {
        if (this.__nav) this.__nav.removeEventListener('click', this.__onPageClick);
        if (this.__viewport) {
          this.__viewport.removeEventListener('pointerdown', this.__onPointerDown);
          this.__viewport.removeEventListener('pointerup', this.__onPointerUp);
        }
        document.removeEventListener('shopify:section:load', this.__onSectionLoad);
        window.clearTimeout(this.__timer);
        this.__bound = false;
      }

      __setActive(index, wrap) {
        const total = this.__slides.length;
        if (!total) return;
        if (wrap) index = (index + total) % total;
        if (index < 0 || index >= total || index === this.__index) return;
        this.__index = index;
        this.dataset.activeIndex = String(index);
        this.classList.add('is-transitioning');
        this.__slides.forEach((slide, i) => {
          if (i === index) {
            slide.setAttribute('data-active', '');
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.removeAttribute('data-active');
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        this.__buttons.forEach((button, i) => {
          if (i === index) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
        if (this.__live) {
          const strings = window.__reviewsCarouselStrings || {};
          this.__live.textContent =
            (strings.livePrefix || '') +
            (index + 1) +
            (strings.liveMid || '') +
            total;
        }
        window.clearTimeout(this.__timer);
        this.__timer = window.setTimeout(() => this.classList.remove('is-transitioning'), 300);
      }
    }
    customElements.define('reviews-carousel', ReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salon-detail-info"] && !Shopify.designMode) return;
  try {
    
  /* Price list anchor-scroll (price-list type 'anchor'). The section is
     otherwise static - no events published or subscribed. Instant under
     prefers-reduced-motion (behaviour 'auto'), smooth otherwise. One
     document-level delegated listener behind a registry flag: survives
     Section Rendering API HTML replacement, never double-fires. */
  if (!window.__salonDetailInfoDelegated) {
    window.__salonDetailInfoDelegated = true;
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-salon-price-list-scroll]');
      if (!trigger) return;
      const target = document.querySelector(trigger.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salon-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('salon-map')) {
    customElements.define(
      'salon-map',
      class SalonMap extends HTMLElement {
        connectedCallback() {
          if (this.__bound) return;
          this.__bound = true;

          this.addEventListener('click', this.__onPinClick = (event) => {
            const pin = event.target.closest('[data-city]');
            if (!pin || !this.contains(pin)) return;

            const city = pin.getAttribute('data-city');
            const strings = window.__salonMapStrings || {};

            // One owner per trigger: the pin publishes; the city-accordion
            // section owns opening the group and scrolling it into view.
            document.dispatchEvent(
              new CustomEvent('salon-map:city-select', {
                bubbles: true,
                detail: { city: city, label: strings.pin_label }
              })
            );
            /* The city-accordion section's subscribed contract name (its
               brief, section 6) - both names publish so either consumer
               binds to the name its brief declared. */
            document.dispatchEvent(
              new CustomEvent('salon-city:open', {
                bubbles: true,
                detail: { city: city }
              })
            );
          });

          /* Sync pin state from the accordion side - one handler owns the
             [aria-expanded] mirror, keyed off the accordion's toggle
             event (detail: { city, open }). */
          this.__onCityToggle = (event) => {
            const detail = event.detail || {};
            if (!detail.city) return;
            this.querySelectorAll('[data-city]').forEach((pin) => {
              const isActive =
                pin.getAttribute('data-city') === detail.city && !!detail.open;
              pin.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            });
          };
          document.addEventListener('salon-city:toggle', this.__onCityToggle);
          document.addEventListener('city-accordion:changed', this.__onCityToggle);
        }

        disconnectedCallback() {
          if (!this.__bound) return;
          this.removeEventListener('click', this.__onPinClick);
          document.removeEventListener('salon-city:toggle', this.__onCityToggle);
          document.removeEventListener('city-accordion:changed', this.__onCityToggle);
          this.__bound = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-copy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seo-copy')) {
    class SeoCopy extends HTMLElement {
      constructor() {
        super();
        this.__bound = false;
      }

      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;

        this.__body = this.querySelector('.seo-copy__body:not(.seo-copy__more)');
        this.__more = this.querySelector('.seo-copy__more');
        this.__toggle = this.querySelector('[data-seo-copy-toggle]');
        if (!this.__body || !this.__toggle) return;

        this.__collapsed = false;
        this.__expandedByUser = false;

        /* Ticket 20374903 (#126): MORE mode - a second metafield holds the
           copy, so there is always something to reveal: no measuring, no
           clamp, no resize listener. Hide it and show the button straight
           away; the markup ships it visible for the no-JS render. */
        if (this.dataset.mode === 'more') {
          if (!this.__more) return;
          this.__setCollapsed(true);
          this.__more.hidden = true;
          this.__toggle.hidden = false;
          this.__toggle.addEventListener('click', this.__onToggle);
          return;
        }

        this.__applyClamp();
        this.__toggle.addEventListener('click', this.__onToggle);

        /* Re-measure once the real fonts are in. connectedCallback runs during
           parse, so the first measurement uses fallback metrics: the copy
           measured taller than it finally renders, the toggle un-hid, and then
           the webfont reflowed it back under the cap - leaving a visible
           "Read more" that revealed nothing on click (QA 3 Sep 2026). */
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.__remeasure());
        }
        /* And again when the layout changes: the column width changes with
           the viewport, so the copy rewraps and a resize can change whether
           the 6-line clamp hides anything at all. */
        window.addEventListener('resize', this.__onResize);
      }

      disconnectedCallback() {
        if (this.__toggle) this.__toggle.removeEventListener('click', this.__onToggle);
        window.removeEventListener('resize', this.__onResize);
        clearTimeout(this.__resizeTimer);
        this.__bound = false;
      }

      __onResize = () => {
        clearTimeout(this.__resizeTimer);
        this.__resizeTimer = setTimeout(() => this.__remeasure(), 150);
      };

      /* A shopper who has opened the copy keeps it open - re-measuring must
         never snap it shut under them. */
      __remeasure() {
        if (!this.__body || !this.__toggle || this.__expandedByUser) return;
        this.__applyClamp();
      }

      /* Clamp only when collapsing actually hides something - short copy
         never renders a dead toggle (checklist 9). Measured on the
         un-clamped body: every rendered line box of its text, de-duplicated
         by position, in the single column every breakpoint now uses. More
         than 6 lines -> cap the height at the bottom of the 6th, so the cut
         lands on a whole line; 6 or fewer -> no clamp, no toggle. The
         clamped box is never measured, so no CSS quirk (the line-clamp that
         never applied - see the stylesheet) can fake an overflow again. */
      __applyClamp() {
        /* The signed contract marks read-more FIXED: the collapse threshold
           is a code constant (6 lines - the clone's default), not a setting. */
        const lines = 6;
        this.style.setProperty('--seo-copy-lines', String(lines));

        this.__body.classList.remove('seo-copy__body--clamped');
        this.__body.style.removeProperty('--seo-copy-max');
        const top = this.__body.getBoundingClientRect().top;

        const bottoms = [];
        const walker = document.createTreeWalker(this.__body, NodeFilter.SHOW_TEXT);
        const range = document.createRange();
        while (walker.nextNode()) {
          if (!walker.currentNode.textContent.trim()) continue;
          range.selectNodeContents(walker.currentNode);
          for (const rect of range.getClientRects()) {
            if (rect.height === 0) continue;
            const bottom = Math.round(rect.bottom - top);
            if (!bottoms.some((b) => Math.abs(b - bottom) < 2)) bottoms.push(bottom);
          }
        }
        bottoms.sort((a, b) => a - b);

        if (bottoms.length <= lines) {
          this.__toggle.hidden = true;
          this.__collapsed = false;
          return;
        }

        this.__body.style.setProperty('--seo-copy-max', bottoms[lines - 1] + 'px');
        this.__body.classList.add('seo-copy__body--clamped');
        this.__setCollapsed(true);
        this.__toggle.hidden = false;
      }

      __setCollapsed(collapsed) {
        this.__collapsed = collapsed;
        this.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        this.__toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        const strings = window.__seoCopyStrings || {};
        const label = collapsed
          ? this.__toggle.dataset.labelMore || strings.readMore
          : this.__toggle.dataset.labelLess || strings.readLess;
        this.__toggle.querySelector('.seo-copy__toggle-label').textContent = label;
      }

      /* Collapsing re-measures rather than re-adding the old cap: the
         viewport may have changed while the copy was open. */
      __onToggle = () => {
        /* Ticket 20374903 (#126): MORE mode just shows / hides the block. */
        if (this.dataset.mode === 'more') {
          this.__setCollapsed(!this.__collapsed);
          this.__more.hidden = this.__collapsed;
          return;
        }
        if (this.__collapsed) {
          this.__body.classList.remove('seo-copy__body--clamped');
          this.__setCollapsed(false);
          this.__expandedByUser = true;
        } else {
          this.__expandedByUser = false;
          this.__applyClamp();
        }
      };
    }
    customElements.define('seo-copy', SeoCopy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('usp-banner')) {
    class UspBanner extends HTMLElement {
      constructor() {
        super();
        this.__bound = false;
        this.__timer = null;
        this.__activeIndex = 0;
      }

      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.__list = this.querySelector('.usp-banner__list');
        this.__items = Array.from(this.querySelectorAll('.usp-banner__item'));
        this.__live = this.querySelector('[data-usp-live]');
        this.__dots = Array.from(this.querySelectorAll('[data-usp-dots] .usp-banner__dot'));
        this.__dwell = parseInt(this.dataset.dwell, 10) || 4000;

        if (this.__items.length < 2) return;

        /* Only the rotator hides messages from the accessibility tree - the
           markup ships with every item exposed, because desktop shows all of
           them at once. The attribute lands here (mobile rotation) and is
           cleared whenever rotation stops. */
        this.__reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.__mobile = window.matchMedia('(max-width: 749px)');
        this.__onVisibility = () => this.__sync();
        this.__onMobileChange = () => this.__sync();
        this.__onMotionChange = () => this.__sync();

        this.__reducedMotion.addEventListener('change', this.__onMotionChange);
        this.__mobile.addEventListener('change', this.__onMobileChange);
        document.addEventListener('visibilitychange', this.__onVisibility);
        this.__sync();
      }

      disconnectedCallback() {
        this.__stop();
        if (this.__reducedMotion) this.__reducedMotion.removeEventListener('change', this.__onMotionChange);
        if (this.__mobile) this.__mobile.removeEventListener('change', this.__onMobileChange);
        document.removeEventListener('visibilitychange', this.__onVisibility);
        this.__bound = false;
      }

      /* Rotation runs only on mobile, only with motion allowed, only while
         the tab is visible. Desktop is a static row - the timer is inert and
         every item stays in the accessibility tree. */
      __sync() {
        const shouldRotate =
          this.__mobile.matches &&
          !this.__reducedMotion.matches &&
          !document.hidden;
        if (shouldRotate) {
          this.__start();
        } else {
          this.__stop();
          this.__exposeAll();
        }
      }

      /* When nothing rotates, every message is on screen (desktop) or the
         first one is (paused mobile) - nothing may stay aria-hidden. */
      __exposeAll() {
        this.__items.forEach((item) => item.removeAttribute('aria-hidden'));
      }

      __start() {
        if (this.__timer) return;
        this.__timer = setInterval(() => this.__advance(), this.__dwell);
      }

      __stop() {
        if (this.__timer) {
          clearInterval(this.__timer);
          this.__timer = null;
        }
      }

      __advance() {
        this.__activeIndex = (this.__activeIndex + 1) % this.__items.length;
        this.__apply();
      }

      __apply() {
        this.__list.dataset.active = String(this.__activeIndex);
        this.__items.forEach((item, index) => {
          const active = index === this.__activeIndex;
          item.classList.toggle('is-active', active);
          if (active) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });
        this.__dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.__activeIndex);
        });
        if (this.__live) {
          const strings = window.__uspBannerStrings;
          this.__live.textContent = String(strings.liveTemplate)
            .replace('@i', String(this.__activeIndex + 1))
            .replace('@y', String(this.__items.length));
        }
      }
    }
    customElements.define('usp-banner', UspBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('wishlist-page')) return;

    var busy = false;

    function render(root, attempt) {
      var api = window.__wishlist;
      /* Section and snippet JS share one bundle with no guaranteed order, so
         the runtime may not be defined yet on first paint. Retry briefly
         instead of bailing for good. */
      if (!api) {
        var tries = attempt || 0;
        if (tries < 40) setTimeout(function () { render(root, tries + 1); }, 50);
        return;
      }
      if (busy) return;
      busy = true;
      var handles = api.get();
      var grid = root.querySelector('[data-wishlist-grid]');
      var empty = root.querySelector('[data-wishlist-empty]');
      var missing = root.querySelector('[data-wishlist-missing]');
      var countText = root.querySelector('[data-wishlist-count-text]');
      if (!grid) { busy = false; return; }

      var rootUrl = root.getAttribute('data-root-url') || '/';
      /* One fetch per saved handle against the wishlist-card product view, so
         any product in the catalogue renders through the one card definition. */
      var jobs = handles.map(function (handle) {
        return fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '?view=wishlist-card')
          .then(function (res) { return res.ok ? res.text() : ''; })
          .then(function (html) { return { handle: handle, html: (html || '').trim() }; })
          .catch(function () { return { handle: handle, html: '' }; });
      });

      Promise.all(jobs).then(function (cards) {
        grid.textContent = '';
        var shown = 0;
        cards.forEach(function (card) {
          if (!card.html) return;
          var li = document.createElement('li');
          li.className = 'wishlist__item';
          li.setAttribute('data-handle', card.handle);
          li.innerHTML = card.html;
          grid.appendChild(li);
          shown += 1;
        });

        var template = root.getAttribute('data-count-template') || '__COUNT__ saved';
        if (countText) {
          countText.textContent = shown ? template.replace('__COUNT__', String(shown)) : '';
        }
        if (empty) empty.hidden = shown > 0;
        grid.hidden = shown === 0;
        if (missing) missing.hidden = !(handles.length > shown);
        /* Repaint the injected hearts so saved state shows immediately. */
        if (api.paint) api.paint(grid);
        busy = false;
      });
    }

    customElements.define(
      'wishlist-page',
      class WishlistPage extends HTMLElement {
        connectedCallback() {
          this.__render = render.bind(null, this);
          this.__render();
          document.addEventListener('wishlist:updated', this.__render);
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:updated', this.__render);
        }
      }
    );

    /* The section root is a plain <section> (it is placed by a JSON template),
       so upgrade behaviour is attached by wrapping at runtime instead. */
    function boot() {
      document.querySelectorAll('[data-wishlist-page]').forEach(function (node) {
        if (node.__wishlistBound) return;
        node.__wishlistBound = true;
        var paint = render.bind(null, node);
        paint();
        document.addEventListener('wishlist:updated', paint);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
